(function () {
    'use strict';

    angular
        .module('app.layout')
        .controller('SidebarController', SidebarController);

    /* @ngInject */
    function SidebarController($q, $scope, $state, routerHelper, PermPermissionMap,
        PermAuthorization, currentUser, pendingUserService) {
        var vm = this;
        var states = routerHelper.getStates();
        vm.expandedRoutes = [];

        vm.isCurrent = isCurrent;
        vm.isChildCurrent = isChildCurrent;
        vm.isCollapsable = isCollapsable;
        vm.isExpanded = isExpanded;
        vm.stopPropogation = stopPropogation;

        activate();

        function activate() {
            updatePendingUsersBadgeCount();
            getNavRoutes();                    
        }

        function getNavRoutes() {
            $scope.$watch(
              // This function returns the value being watched. It is called for each turn of the $digest loop
              function() {
                  return currentUser && currentUser.roles;
              },
              // This is the change listener, called when the value returned from the above function changes
              function () {
                  var statePromises = statesChanged();
                  allStatesAuthorized(statePromises);
              });

        }

        function statesChanged() {           
            var statePromises = [];
            angular.forEach(states, function (r) {
                var state = r;
                var role = state.data && state.data.permissions;
                if (!!role) {
                    var permissionMap = new PermPermissionMap(role);
                    var authorizationResult = PermAuthorization.authorizeByPermissionMap(permissionMap);

                    this.push(
                        authorizationResult
                        .then(function () {
                            return state;
                        }));
                } else {
                    this.push($q.when(state));
                }
            }, statePromises);
            return statePromises;
        }

        function allStatesAuthorized(statePromises) {
            $q.allSettled(statePromises)
                .then(function (states) {
                    vm.navRoutes = states.filter(function (r) {
                        return r.value && r.value.settings && r.value.settings.nav && r.value.settings.isVisible;
                    }).sort(function (r1, r2) {
                        return r1.value.settings.nav - r2.value.settings.nav;
                    }).map(function (result) {
                        return result.value;
                    });
                }).catch(function (err) {
                    console.log('Error with states: ', err);
                });
        }

        function isCurrent(route) {
            if (!route.title || !$state.current || !$state.current.title) {
                return '';
            }
            var menuName = route.title;    
            return $state.current.title.substr(0, menuName.length) === menuName;
        }

        function isChildCurrent(route) {
            if (!route.state || !$state.current || !$state.current.name) {
                return '';
            }

            var menuName = route.state;
            var currentTitle = $state.current.name;
            return currentTitle.substr(0, menuName.length) === menuName ? 'selected' : '';
        }

        function isCollapsable(route) {
            if (!route.settings || !route.settings.hasChildren) {
                return;
            }

            if (routeExistsInExpandedRoutes(route)) {
                removeRouteFromExpandedRoutes(route);
            } else {
                vm.expandedRoutes.push(route);    
            }
        }

        function isExpanded(route) {
            if (!route.name || !vm.expandedRoutes.length) {
                return;
            }

            return routeExistsInExpandedRoutes;            
        }

        function routeExistsInExpandedRoutes(route) {
            var hasRoute = _.find(vm.expandedRoutes, { name: route.name });
            return !!hasRoute;
        }

        function removeRouteFromExpandedRoutes(route) {
            vm.expandedRoutes = vm.expandedRoutes.filter(function (e) {
                return e.name !== route.name;
            });         
        }

        function stopPropogation($event) {
            $event.stopPropagation();
        }

        function updatePendingUsersBadgeCount() {
            // gets user count which fires an emmit event to update badge on Pending Users
            if (currentUser.isInRole('SSO:SysAdmin') || currentUser.isInRole('SSO:AppAdmin')) {
                pendingUserService.getPendingUsersCount();
            }            
        }
    }
})();
